import { StyledEngineProvider } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material/styles'
import theme from '../../theme'
import 'animate.css'
import classes from './Invader.module.css'

const Invader = (props) => {
  let autoDiv = []
  let checkTrulyCellInTheGrid

  // put together results of getShape and getColor
  function getTotalGrid(shape, color) {
    for (var j = 0; j < shape.length; j++) {
      checkTrulyCellInTheGrid = shape[j] === true
      autoDiv.push(
        <div
          className={
            classes.divBox + ' ' + checkTrulyCellInTheGrid + ' ' + color[j]
          }
          key={j}
        ></div>,
      )
    }
    return autoDiv
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div className={classes.innerContainer}>
          {getTotalGrid(props.shape, props.color)}
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default Invader
